// extracted by mini-css-extract-plugin
export default {"edit-address-mobile__title":"edit-address-mobile__title_P8dTdSJG","edit-address-mobile__add-new-address":"edit-address-mobile__add-new-address_gJkkpJS6"};